import Vue from 'vue';

const routerTransfer = new Vue({});
export default routerTransfer;
